export default {"src":"/_next/static/media/china-ems.218065c2.svg","height":512,"width":512};